import { importProvidersFrom, inject, provideEnvironmentInitializer } from "@angular/core";
import { provideSoftAppsModule, withLazySoftAppsModuleTranslation, withSoftAppsModuleRoutes } from '@softapps/core';
import { SOFTLINE_SERVICE_HTTP, SOFTLINE_STORE_ENTITY_SERVICE, SoftlineEntityService, Store, StoreModule } from "@softline/core"
import { ApplicationStore, SOFTLINE_FEATURE_APPLICATIONS } from "@softline/application"
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from "@softline/ui-core";
import { default as de } from './../i18n/de.json';
import { default as deTitles } from './../i18n/de.titles.json';
import { SOFTLINE_FEATURE_PMS_MELDUNGEN, SOFTLINE_PERMISSION_PMS_MELDUNGEN } from "./meldungen.shared";
import { PmsMeldungenStore } from "./store/meldungen.store";
import { SOFTLINE_API_PMS_MELDUNGEN } from "./meldungen.api";
import { pmsMeldungRoutes } from './meldungen.routes';
import { providePmsMeldungGlobals } from './meldungen.globals';

export function providePmsMeldungModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'pmsMeldungen',
        title: 'Meldungen',
        icon: 'fa-regular fa-triangle-exclamation',
        route: '/pmsmeldung',
        permission: SOFTLINE_PERMISSION_PMS_MELDUNGEN,
      },
      withSoftAppsModuleRoutes({ app: pmsMeldungRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('./../i18n/de.json') },
      })
    ),
    ...providePmsMeldungGlobals(),
  ];
}

export const pmsMeldungProviders = [
  provideEnvironmentInitializer(async () => {
      const store = inject(Store);

      store.commit(
        SOFTLINE_FEATURE_TRANSLATION,
        TranslationStore.mutations.add,
        {
          module: 'pmsMeldungen',
          language: 'de',
          translations: de,
        }
      );

      store.commit(
        SOFTLINE_FEATURE_APPLICATIONS,
        ApplicationStore.mutations.add,
        {
          name: 'Meldungen',
          route: '/pmsmeldung',
          icon: 'fa-regular fa-triangle-exclamation',
          permission: SOFTLINE_PERMISSION_PMS_MELDUNGEN
        }
      );
    }),
  importProvidersFrom(
    StoreModule.forFeature({
      name: SOFTLINE_FEATURE_PMS_MELDUNGEN,
      feature: PmsMeldungenStore.feature,
      providers: [{
        provide: SOFTLINE_STORE_ENTITY_SERVICE,
        useFactory: () => new SoftlineEntityService(
          inject(SOFTLINE_SERVICE_HTTP),
          SOFTLINE_API_PMS_MELDUNGEN
        )
      }]
    })
  )
];
